import TaskEditorStack from 'containers/Tasks/TasksManagement/TaskEditorStack';
import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { parse } from 'query-string';
// import { Tab } from 'store/entity/types';
import { IField } from 'store/tasks/tasksType';

interface IOwnProps {
  companyId?: string;
  projectId?: number;
  tab?: string;
  taskId?: number;
  templateId?: number;
  providerItem?: any;
  fields?: IField[];
  embedded?: boolean;
  directTask?: boolean;
  onTaskCreate?: (taskId: number) => any;
  onClose?: () => any;
  autoFillFields?: { [key: string]: any };
  disableStack?: boolean | undefined;
}

type IComponentProps = IOwnProps & RouteComponentProps;

// const tabTypes: Tab[] = ['info', 'conversation', 'attachments'];

const TaskEditorWrapper: React.FC<IComponentProps> = ({
  companyId,
  projectId,
  // tab,
  taskId,
  templateId,
  providerItem,
  location,
  fields,
  embedded,
  onTaskCreate,
  directTask,
  onClose,
  autoFillFields = {},
  disableStack,
}) => {
  const url = new URLSearchParams(window.location.search);
  const tempId = Number(url.get('tempId'));

  const field = url.get('field') || '';
  const mappedValue = url.get('fieldVal') || '';
  autoFillFields[field] = mappedValue;

  let parsed;
  if (location) {
    parsed = parse(location.search);
  }
  return (
    <div className="h-full">
      <TaskEditorStack
        companyId={Number(companyId)}
        projectId={projectId}
        providerItem={companyId ? providerItem : undefined}
        taskId={taskId}
        templateId={
          tempId
            ? tempId
            : location && parsed && parsed.template
              ? Number(parsed.template)
              : templateId
        }
        parentId={
          location && parsed && parsed.parent
            ? Number(parsed.parent)
            : undefined
        }
        fields={fields}
        embedded={embedded}
        onTaskCreate={onTaskCreate}
        onCloseTask={onClose}
        directTask={directTask}
        autoFillFields={autoFillFields}
        disableStack={disableStack}
      />
    </div>
  );
};

export default TaskEditorWrapper;
